import app from './search-app';

app.$store.commit('setLocation', window.search.location);
app.$store.commit('setAds', window.search.ads);
app.$store.commit('setDistrict', window.search.district.length > 0 ? window.search.district.split('|') : []);
app.$store.commit('setPagination', window.search.pagination);
app.$store.commit('setSort', window.search.sort);
app.$store.commit('setFilter', window.search.filter);
app.$store.commit('setType', window.search.type);
app.$store.commit('setAmenities', window.search.amenities);
app.$store.commit('setDistricts', window.search.districts);
app.$store.commit('setPageTitle', window.search.page_title);
app.$store.commit('setCurrencySign', window.search.sign);
app.$store.commit('setCityName', window.search.city_name);

app.$mount('#ssr_root');
